__webpack_require__.p = "https://catan.francofrizzo.com/";